import type { FormNode } from '../../designer/types/form.types'

function parseObjectDataPath(dp?: string): string | null {
  if (!dp?.trim()) return null
  const p = dp.trim()
  if (p.startsWith('Object.')) return p.slice('Object.'.length)
  return null
}

/**
 * Binding name for an InputField: `Object.x` → `x`, bare `x` → `x`, else
 * `node.name` (aligns with DefaultInputField).
 *
 * Leaf module on purpose: consumers that need only this resolution must not
 * import the FormRenderer component module, which every RuntimeFormRenderer
 * test replaces with a jest mock.
 */
export function resolveInputFieldAttrName(node: FormNode): string | null {
  const fromObject = parseObjectDataPath(node.dataPath)
  if (fromObject?.trim()) return fromObject.trim()
  const dp = node.dataPath?.trim()
  if (dp) return dp
  const nm = node.name?.trim()
  return nm || null
}
